// extracted by mini-css-extract-plugin
export var cartIcon = "_p0-0";
export var cartIconContainer = "_p0-1";